import moment from 'moment'

export const isDateTodayOrLater = (date) => moment(date).isAfter(moment().subtract(1, 'day'))
